import { useQuery } from "@tanstack/react-query";
import { getCategoriesForSelect } from "../../api/apiCategories";
import i18next from "i18next";

/**
 * Hook لجلب الفئات لاستخدامها في قوائم الاختيار (Select)
 * @param {Object} params - Query parameters (e.g. department_id)
 */
export function useGetCategoriesForSelect(params = {}) {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ["categoriesForSelect", params, i18next.language],
        queryFn: () => getCategoriesForSelect(params),
        retry: false,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
        refetch
    };
}
